export default __webpack_public_path__ + "static/media/trash-icon-red.4ba35eed.svg";